import React from 'react';
import { STORE_TYPE } from '../../../common/types/types';
import { AnnotationHeader, DeleteButton, ShowHideButton, useShowHideHandler } from '../annotation-header';
import type { HeaderInfoT } from './types';
type PropsT = {
  headerInfo: HeaderInfoT;
  label: string;
  icon: React.ReactNode;
  onDeleteAllAnnotations: () => void;
};
export function AnnotationDetailsHeader({
  headerInfo,
  label,
  icon,
  onDeleteAllAnnotations
}: PropsT) {
  const {
    handleShowHideAnnotation
  } = useShowHideHandler({
    headerInfo,
    storeType: STORE_TYPE.ANNOTATION_STORE,
    label
  });
  function handleShowHide() {
    handleShowHideAnnotation();
  }
  return <AnnotationHeader headerInfo={headerInfo} label={label} icon={icon} showHideButton={(_, headerInfo) => <ShowHideButton headerInfo={headerInfo} onClick={handleShowHide} />} deleteButton={() => <DeleteButton onClick={onDeleteAllAnnotations} />} />;
}